import * as radixScales from '@radix-ui/colors';

const blackOverlay = {
    overlay1: radixScales.blackA.blackA1,
    overlay2: radixScales.blackA.blackA2,
    overlay3: radixScales.blackA.blackA3,
    overlay4: radixScales.blackA.blackA4,
    overlay5: radixScales.blackA.blackA5,
    overlay6: radixScales.blackA.blackA6,
    overlay7: radixScales.blackA.blackA7,
    overlay8: radixScales.blackA.blackA8,
    overlay9: radixScales.blackA.blackA9,
    overlay10: radixScales.blackA.blackA10,
    overlay11: radixScales.blackA.blackA11,
    overlay12: radixScales.blackA.blackA12,
};
const whiteOverlay = {
    overlay1: radixScales.whiteA.whiteA1,
    overlay2: radixScales.whiteA.whiteA2,
    overlay3: radixScales.whiteA.whiteA3,
    overlay4: radixScales.whiteA.whiteA4,
    overlay5: radixScales.whiteA.whiteA5,
    overlay6: radixScales.whiteA.whiteA6,
    overlay7: radixScales.whiteA.whiteA7,
    overlay8: radixScales.whiteA.whiteA8,
    overlay9: radixScales.whiteA.whiteA9,
    overlay10: radixScales.whiteA.whiteA10,
    overlay11: radixScales.whiteA.whiteA11,
    overlay12: radixScales.whiteA.whiteA12,
};
function mapColor(color, alias) {
    const obj = {};
    for (let i = 1; i <= 12; i++) {
        obj[alias + i] = '$' + color + i;
    }
    return obj;
}
function mapColorObj(color, originalPrefix, alias) {
    const obj = {};
    for (let i = 1; i <= 12; i++) {
        obj[alias + i] = color[originalPrefix + i];
    }
    return obj;
}
const lightDefaults = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ hiContrast: 'black', loContrast: 'white', transparentPanel: 'hsl(0 0% 0% / 97%)' }, blackOverlay), radixScales.whiteA), radixScales.pink), mapColor('whiteA', 'overlayB')), mapColorObj(radixScales.grayDarkA, 'grayA', 'grayDarkA')), radixScales.gray), radixScales.mauve), radixScales.slate), radixScales.sage), radixScales.olive), radixScales.sand), radixScales.violet), radixScales.indigo), radixScales.blue), radixScales.grayA), radixScales.mauveA), radixScales.slateA), radixScales.sageA), radixScales.oliveA), radixScales.sandA), radixScales.violetA);
const darkDefaults = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, whiteOverlay), radixScales.grayDark), radixScales.mauveDark), radixScales.slateDark), radixScales.sageDark), radixScales.oliveDark), radixScales.sandDark), mapColorObj(radixScales.grayA, 'grayA', 'grayDarkA')), radixScales.violetDark), radixScales.indigoDark), radixScales.blueDark), radixScales.grayDarkA), radixScales.mauveDarkA), radixScales.slateDarkA), radixScales.sageDarkA), radixScales.oliveDarkA), radixScales.sandDarkA), radixScales.violetDarkA), { 
    // ...radixScales.indigoDarkA,
    // ...radixScales.blueDarkA,
    // ...radixScales.skyDarkA,
    // ...radixScales.mintDarkA,
    // ...radixScales.cyanDarkA,
    // ...radixScales.tealDarkA,
    // ...radixScales.greenDarkA,
    // ...radixScales.grassDarkA,
    // ...radixScales.limeDarkA,
    // ...radixScales.yellowDarkA,
    // ...radixScales.amberDarkA,
    // ...radixScales.orangeDarkA,
    // ...radixScales.brownDarkA,
    // ...radixScales.bronzeDarkA,
    // ...radixScales.goldDarkA,
    // Semantic colors
    hiContrast: 'white', loContrast: 'black', 
    // // Semantic colors
    // hiContrast: '$gray12',
    // // loContrast: '$gray1',
    // loContrast: '$loContrast',
    canvas: 'hsl(0 0% 15%)', panel: '$gray3', transparentPanel: 'hsl(0 100% 100% / 97%)', shadowLight: 'hsl(206 22% 7% / 35%)', shadowDark: 'hsl(206 22% 7% / 20%)' }), mapColor('blackA', 'overlayB'));
function createThemeValue(theme, variables) {
    const { primary, secondary, accent, gray, error, success, info, warning, } = theme;
    const suffix = theme.isLight ? '' : 'Dark';
    const colors = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (theme.isLight ? lightDefaults : darkDefaults)), radixScales[primary + suffix]), radixScales[primary + suffix + 'A']), radixScales[secondary + suffix]), radixScales[secondary + suffix + 'A']), radixScales[accent + suffix]), radixScales[accent + suffix + 'A']), radixScales[gray + suffix]), radixScales[gray + suffix + 'A']), radixScales[error + suffix]), radixScales[error + suffix + 'A']), radixScales[success + suffix]), radixScales[success + suffix + 'A']), radixScales[info + suffix]), radixScales[info + suffix + 'A']), radixScales[warning + suffix]), radixScales[warning + suffix + 'A']), mapColor(error, 'error')), mapColor(error + 'A', 'errorA')), mapColor(success, 'success')), mapColor(success + 'A', 'successA')), mapColor(info, 'info')), mapColor(info + 'A', 'infoA')), mapColor(warning, 'warning')), mapColor(warning + 'A', 'warningA')), mapColor(gray, 'gray')), mapColor(gray + 'A', 'grayA')), mapColor(primary, 'primary')), mapColor(primary + 'A', 'primaryA')), mapColor(accent, 'accent')), mapColor(accent + 'A', 'accentA')), mapColor(secondary, 'secondary')), mapColor(secondary + 'A', 'secondaryA')), variables);
    return { colors };
}

export { blackOverlay, createThemeValue, mapColor, mapColorObj, whiteOverlay };
